/**
 * スムーススクロール
 *
 * classに js-smoothScroll を指定した要素がクリックされた際、ページ内リンクをスムーススクロールにする
 */
$(() => {
    $('.js-smoothScroll').on('click', (event) => {
        const href = $(event.currentTarget).attr('href');

        // # から始まるhrefがない場合は何もしない
        if (!href || href.indexOf('#') !== 0) {
            return;
        }

        // 存在しないid要素が指定されている場合は何もしない
        const $target = $(href);
        if (!$target.length) {
            return;
        }

        const position = $target.offset().top;
        const scrollSpeedMs = 300;
        $('body,html').animate({scrollTop:position}, scrollSpeedMs, 'swing');

        event.preventDefault();
    });
});
